const INFO = {
	main: {
		title: "Pavan",
		name: "Pavan",
		email: "pavan.khiani@gmail.com",
		logo: "../Pavan Icon.png",
	},

	socials: {
		github: "https://github.com/pkhiani",
		linkedin: "https://linkedin.com/in/pavan-khiani",
		medium: "https://pkhiani.medium.com/",
		spotify: "https://open.spotify.com/show/5dlhqXHwdjDkiuOOvhcRa5?si=3063c552d402433f"
	},

	homepage: {
		title: "Product Manager & Content Creator",
		description:
			"I’ve been around the worlds of business and technology since I was a kid, which eventually landed me a Business and Computer Science degree from UBC. When I’m not working, you’ll probably find me travelling somewhere far from home, touching grass, and making content while pretending I know what I'm doing."	
		},

	projects: [
		{
			title: "Networker.ai",
			description:
				"Generate personalized LinkedIn messages using AI.",
			logo: "https://raw.githubusercontent.com/pkhiani/networker-ai/refs/heads/main/icon.png",
			linkText: "View Project",
			link: "https://chromewebstore.google.com/detail/networkerai/innhhchcboconofndjjlonpckbkljjim",
		},
		{
			title: "KYCrypto",
			description:
				"AI powered crypto portfolio allocation based on risk tolerance and market experience.",
			logo: "https://raw.githubusercontent.com/pkhiani/kycrypto/refs/heads/main/icon.png",
			linkText: "View Project",
			link: "https://kycrypto.ca/",
		},
		{
			title: "Write a Blog",
			description:
				"Create SEO-optimized blog posts with the power of AI.",
			logo: "https://raw.githubusercontent.com/pkhiani/blog-writer/refs/heads/main/public/icon.png",
			linkText: "View Project",
			link: "https://writeablog.pavankhiani.xyz/",
		},
	],
};

export default INFO;
